class AmazonPayController {
    /*@ngInject*/
    constructor($scope, $log, $http, $rootScope, CommonService, ProductDetailService) {
        $log.debug('AmazonPayController initialized');
        this.$scope = $scope;
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.commonService = CommonService;
        this.productDetailService = ProductDetailService;
        this.isSoftLoggedCustomer = false;
        this.amazonPayButton = undefined;
        this.amazonCreateCheckoutSessionBean = undefined;
        this.showNotLoggedInMsg = false;
        this.productType = 'PayAndShip';
        this.buttonColor = undefined;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isSoftLoggedCustomer = this.commonService.getPersonalizeRequestResponse().isLoggedIn
                && !this.commonService.getPersonalizeRequestResponse().isHardLoggedIn;
        });
    }

    showButton(placement) {
        const url = this.commonService.getBaseUrl() + '/amazonpay/getButtonData?placement=' + placement

        this.$http
            .get(url)
            .then((response) => {
                let amazonPayButton = response.data;
                this.amazonCreateCheckoutSessionBean = amazonPayButton.amazonCreateCheckoutSessionBean;
                this.buttonColor = amazonPayButton.amazonPayButtonColor;
                if (amazonPayButton.amazonPayEnabled && this.amazonCreateCheckoutSessionBean) {
                    if (placement === 'Checkout') {
                        this.loadCommonCheckoutButtonAndClickIt('Checkout');
                    } else if (placement === 'Product' && amazonPayButton.amazonPayExpressEnabled) {
                        this.loadExpressCheckoutButton(placement);
                    } else if (placement === 'Cart') {
                        this.loadCartButton(placement);
                    }
                }

            }, (error) => {
                this.$log.error('Amazon pay: ' + error.status + ' ' + error.statusText);
            });
    }

    loadAmazonPayButton(placement) {
        if (this.amazonCreateCheckoutSessionBean !== undefined) {
            this.amazonPayButton = amazon.Pay.renderButton('#amazonPayButton', {
                merchantId: this.amazonCreateCheckoutSessionBean.merchantId,
                publicKeyId: this.amazonCreateCheckoutSessionBean.publicKeyId,
                ledgerCurrency: this.amazonCreateCheckoutSessionBean.ledgerCurrency,
                sandbox: this.amazonCreateCheckoutSessionBean.sandboxEnvironment,
                checkoutLanguage: this.amazonCreateCheckoutSessionBean.checkoutLanguage,
                productType: this.productType,
                placement: placement,
                buttonColor: this.buttonColor
            });
        } else {
            this.$log.error('Amazon pay: checkout session bean is undefined');
        }
    }

    initCheckout() {
        this.amazonPayButton.initCheckout({
            // configure checkout session flow
            createCheckoutSessionConfig: {
                payloadJSON: this.amazonCreateCheckoutSessionBean.payloadJSON,
                signature: this.amazonCreateCheckoutSessionBean.signature,
                publicKeyId: this.amazonCreateCheckoutSessionBean.publicKeyId
            }
        });
    }

    /* Cart page */
    loadCartButton(placement) {
        this.loadAmazonPayButton(placement);
        this.amazonPayButton.onClick(() => {
            if (!this.isSoftLoggedIn()) {
                this.initCheckout();
            }
        });
    }

    /* PDP */
    loadExpressCheckoutButton(placement) {
        this.loadAmazonPayButton(placement);
        this.amazonPayButton.onClick(() => {
            if (!this.isSoftLoggedIn()) {
                this.addToCartRequest(placement);
            }
        });
    }

    /* Checkout page */
    loadCommonCheckoutButtonAndClickIt(placement) {
        this.loadAmazonPayButton(placement);
        this.initCheckout();
    }

    startExpressCheckout(placement) {
        amazon.Pay.initCheckout({
            // set environment
            merchantId: this.amazonCreateCheckoutSessionBean.merchantId,
            publicKeyId: this.amazonCreateCheckoutSessionBean.publicKeyId,
            ledgerCurrency: this.amazonCreateCheckoutSessionBean.ledgerCurrency,
            sandbox: this.amazonCreateCheckoutSessionBean.sandboxEnvironment,
            // customize the buyer experience
            checkoutLanguage: this.amazonCreateCheckoutSessionBean.checkoutLanguage,
            productType: this.productType,
            placement: placement,
            buttonColor: this.buttonColor,
            // configure checkout session flow
            createCheckoutSessionConfig: {
                payloadJSON: this.amazonCreateCheckoutSessionBean.payloadJSON,
                signature: this.amazonCreateCheckoutSessionBean.signature,
                publicKeyId: this.amazonCreateCheckoutSessionBean.publicKeyId
            }
        });
    }

    addToCartRequest(placement) {
        let selectedVariant = this.productDetailService.getVariantData();
        if (selectedVariant === null) {
            this.productDetailService.setWarningSelectSize(true);
            return;
        }
        let productCode = selectedVariant.code;
        if (productCode !== null) {
            this.productDetailService.setWarningSelectSize(false);
            let url = this.commonService.getBaseUrl() + '/amazonpay/createCart?productCode=' + productCode;

            this.$http.post(url, null)
                .then((response) => {
                    if (response.data) {
                        this.$log.debug("Amazon pay express cart has been successfully created and product {" + productCode + "} was added");
                        this.startExpressCheckout(placement);
                    } else {
                        this.$log.error('Amazon pay express, the cart could not be properly created');
                    }
                }, (error) => {
                    this.$log.error('Amazon pay, creating cart error:' + error.status + ' ' + error.statusText);
                });
        }
    }

    isSoftLoggedIn() {
        return this.isSoftLoggedCustomer;
    }

    checkUserStatus() {
        if (this.isSoftLoggedIn()) {
            this.showNotLoggedInMsg = true;
        }
    }
}

export default AmazonPayController;
